import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_report_subscriptions_grid___ds_report_subscriptions_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { only_user_subscriptions?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { name?: string, created_on?: string, created_by?: string, schedule?: string, is_active?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, schedule_name?: string, module_id?: string, report_id?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { only_user_subscriptions?: boolean, $keys: string[] }): Promise<{ result?: { name?: string, created_on?: string, created_by?: string, schedule?: string, is_active?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, schedule_name?: string, module_id?: string, report_id?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      only_user_subscriptions?: boolean    }) {
      return false;
    }
}
